import { render, staticRenderFns } from "./CollectionProtocolParticipantDetail.vue?vue&type=template&id=5a50f1f1&"
import script from "./CollectionProtocolParticipantDetail.vue?vue&type=script&lang=js&"
export * from "./CollectionProtocolParticipantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports